import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/ServersPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/servers'
import { Mutation } from 'react-apollo'
import toggleUserServer from 'graphs/mutations/toggleUserServer.graphql'
import ServerFragment from 'graphs/fragments/ServerFields.graphql'
import SwitchWithMutation from 'components/SwitchWithMutation'

const RouteServersManage = ({ variables, ...props }) => (
  <Mutation mutation={toggleUserServer}>
    {mutate => (
      <Fragment>
        <h3>Servers</h3>
        <PaginatedConnectionTable
          {...props}
          fields={[
            {
              props: {
                dataKey: 'manage',
                key: 'manage',
                render: data => (
                  <SwitchWithMutation
                    initialValue={data.has_user}
                    id={`row-${data.id}`}
                    mutate={mutate}
                    buildMutationOptions={value => ({
                      variables: {
                        input: {
                          server_id: data.id,
                          user_id: variables.user_id,
                          value
                        },
                        user_id: variables.user_id
                      },
                      update: (store, { data: { toggle_user_server } }) => {
                        store.writeFragment({
                          id: data.id,
                          fragment: ServerFragment,
                          variables,
                          data: toggle_user_server
                        })
                      }
                    })}
                    {...props}
                  />
                )
              }
            },
            ...fields
          ]}
          manage
          onRowClick={() => {}}
        />
      </Fragment>
    )}
  </Mutation>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'servers'
})(RouteServersManage)



// WEBPACK FOOTER //
// ./src/routes/admin/users/servers/manage.js